import Vue from 'vue'
import App from './App.vue'

//引入静态
import './assets/css/reset.css'
import './assets/css/color.css'

//引入工具类
import './assets/js/commonUtil.js';

//引入全局过滤器
import './filters'

// 引入router
import router from './router';
// 全局引入axios
import axios from 'axios'
Vue.prototype.$axios = axios;

//引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import Vant from 'vant';
Vue.use(Vant);


//引入jQ
import './assets/js/jquery-1.9.1.min'

//bootstrap
import 'bootstrap/dist/js/bootstrap';

// 引入vant ui

//引入leaflet
import 'leaflet';
import 'leaflet/dist/leaflet.css';

//引入leaflet插件   
import 'leaflet-ant-path'; //航线美化
import 'leaflet.chinatmsproviders'; //底图
import 'leaflet.motion/dist/leaflet.motion'; //航线运动，轨迹回放功能。
import 'leaflet-curve'; //航路点
import 'leaflet-hotline'; //渐变航线
import 'leaflet-rotatedmarker'; //旋转点
import './assets/js/L.tilelayer.drawimg_o.js'; //色斑图颜色渲染。
import './assets/js/run_img';
import './assets/js/leaflet.imageoverlay.arrugator'; //雷达相关
import proj4 from "proj4" //雷达相关
window.proj4 = proj4;
import './assets/js/leaflet-polygon.fillPattern'
import './assets/js/L.LabelTextCollision'


import 'leaflet-tilelayer-wmts/dist/leaflet-tilelayer-wmts'

import 'canvas-marker-layer-gis'

import "leaflet-draw";
import "leaflet-draw/dist/leaflet.draw.css";

import "./assets/js/fragmentShader"; //图例
import './assets/js/legend'; //图例
import 'proj4leaflet';

import './assets/js/leaflet.measure/leaflet.measure'
import './assets/js/leaflet.measure/leaflet.measure.css'

// 引入echarts相关
// import 'leaflet-echarts/dist/leaflet-echarts';
// import 'leaflet-echarts/lib/echarts.source';
// import 'echarts-liquidfill';


//引入turf
import * as turf from '@turf/turf';
Vue.prototype.$turf = turf;

//引入moment
import moment from './assets/js/moment';
window.moment = moment;

//引入pako
import pako from 'pako';
Vue.prototype.$pako = pako;


// utils
// 弹出层
import './utils/alert'
//dialog 可拖动
import './utils/directives'

//引入vuex
import store from './store';
//事件总线
Vue.prototype.$eventBus = new Vue();
//全局组件
import './components'


import { imgURL } from './utils/config'
if (process.env.NODE_ENV === 'development') {
    Vue.prototype.$imgURL = imgURL;
} else {
    Vue.prototype.$imgURL = imgURL;
}

Vue.prototype.$static_URL = process.env.BASE_URL;



//全局守卫
// router.beforeEach((to, from, next) => {
//     if (to.path == '/login') { //如果访问login，则直接放行
//         next();
//     }
//     if (JSON.parse(sessionStorage.getItem('user'))) { //有值代表登录了。
//         axios.get('/api/api/checktoken', {
//             headers: { authorization: `${JSON.parse(sessionStorage.getItem('user')).token}` }
//         }).then(res => {
//             if (res.data.code === 200) {
//                 next();
//             } else if (res.data.code === 403) {
//                 location.href = '/#/login'
//             }
//         })
//     } else {
//         location.href = '/#/login'
//     }
// })


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')